import React from "react";
import { Link } from "react-router-dom";

import "./ReturnTo.component.scss";

interface ReturnToProps {
    to: string | string[];
    label: string | string[];
}

const ReturnToItem = (to: string, label: string)=> (
    <React.Fragment>
        {to ?
            <Link className={"return-to-link"} to={to}>
                <span className={"return-text"}>{label}</span>
            </Link>
            :
            <span className={"return-text"}>{label}</span>
        }
    </React.Fragment>
);

export const ReturnTo = (props: ReturnToProps) => (
    <div className="return-to">
        {(props.label instanceof Array && props.to instanceof Array) ? props.label.map((label, key)=>
            <React.Fragment key={key}>
                {ReturnToItem(props.to[key], label)}
                {key < props.label.length-1 &&
                    <i className={"icon-chevron-right-light return-icon"}></i>
                }

            </React.Fragment>
        ):
            typeof props.to === "string" && typeof props.label === "string" &&
                ReturnToItem(props.to, props.label)
        }
    </div>
);
